var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M860 512L860 540",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.5,
    cy: 507.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M871.829 504.888L861.354 501.027C861.278 500.991 861.202 500.991 861.126 501.027L850.651 504.888C850.651 504.888 850.651 504.888 850.632 504.888C850.613 504.888 850.613 504.906 850.594 504.906C850.594 504.906 850.575 504.906 850.575 504.923C850.556 504.923 850.556 504.941 850.537 504.941C850.537 504.941 850.537 504.941 850.518 504.959C850.499 504.976 850.499 504.976 850.48 504.994C850.48 505.012 850.461 505.012 850.461 505.03V505.047C850.461 505.065 850.461 505.065 850.442 505.083V505.1C850.442 505.118 850.442 505.136 850.442 505.154V509.741C849.626 509.883 849 510.556 849 511.353C849 512.256 849.797 513 850.765 513C851.733 513 852.53 512.256 852.53 511.353C852.53 510.538 851.903 509.883 851.087 509.741V505.579L853.118 506.323V509.387C853.118 510.272 853.991 511.087 855.604 511.689C857.122 512.238 859.115 512.557 861.24 512.557C863.366 512.557 865.377 512.256 866.876 511.689C868.47 511.105 869.362 510.29 869.362 509.387V506.323L871.81 505.419C871.924 505.384 872 505.277 872 505.154C872 505.03 871.943 504.941 871.829 504.888ZM851.922 511.353C851.922 511.937 851.41 512.415 850.784 512.415C850.158 512.415 849.645 511.937 849.645 511.353C849.645 510.768 850.158 510.29 850.784 510.29C851.41 510.29 851.922 510.768 851.922 511.353ZM868.755 509.404C868.755 510.662 865.738 511.99 861.24 511.99C856.743 511.99 853.725 510.644 853.725 509.404V506.553L861.126 509.28C861.164 509.298 861.202 509.298 861.24 509.298C861.278 509.298 861.316 509.298 861.354 509.28L868.755 506.553V509.404ZM868.945 505.88L861.24 508.714L853.535 505.862L851.6 505.154L861.24 501.593L870.88 505.154L868.945 505.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool3);
export default __webpack_public_path__ + "static/media/school_3.48f61f3b79688fa15266347a4f197cca.svg";
export { ForwardRef as ReactComponent };